import urlConfig from 'Url';
import { filterProperty } from '../utils/util';

export const SAVE_ELECT_DATA = 'SAVE_ELECT_DATA';
export const GET_INVOICE = 'GET_INVOICE';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const INIT_ISSUEPSGS = 'INIT_ISSUEPSGS';
export const SELECT_INVOICETITLE_TYPE = 'SELECT_INVOICETITLE_TYPE';
export const ADD_INVOICETITLE = 'ADD_INVOICETITLE';
export const INIT_STATE = 'INIT_STATE';

export function initInvoice() {
  return {
    type: INIT_STATE,
  };
}

/**
 * @description 初始化可开具旅客数据，如果可开具旅客数据为空，则初始化
 * @param {array} psgNum 已选的旅客序号
 */
export function initIssuePsgs(psgNum) {
  return (dispatch, getState) => {
    const {
      EdorsedApply: { psgList },
      electronicInvoice: { issuePsgs },
    } = getState();
    if (issuePsgs.length !== 0) {
      return false;
    }
    const psgs = psgList
      .filter((item, i) => psgNum.indexOf(String(i)) !== -1)
      .map(item => {
        let obj = {
          ticketNo: item.ticketNo,
          psgname: item.psgName,
          psgType: item.psgType,
          idtype: item.certificateType,
          idcard: item.certificateId,
        };
        return obj;
      });
    dispatch({
      type: INIT_ISSUEPSGS,
      psgs,
    });
  };
}

// 查询电子发票
export function getInvoice(data) {
  return {
    type: GET_INVOICE,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.getSvcPcInvoiceInfoByIdAndType,
        method: 'post',
        data,
      },
    },
  };
}

// 新增电子发票抬头
export function addInvoiceTitle(data) {
  return {
    type: ADD_INVOICETITLE,
    payload: {
      request: {
        url: urlConfig.saveSvcPcInvoiceDto,
        method: 'post',
        data,
      },
    },
  };
}

// 选择发票抬头类型
export function selectInvoiceTitleType(n, option) {
  return { type: SELECT_INVOICETITLE_TYPE, n, option };
}

// 保存发票数据
export function saveElectData(i, data) {
  return { type: SAVE_ELECT_DATA, n: i, data };
}

// 生成电子发票
export function createInvoice() {
  return (dispatch, getState) => {
    const { issuePsgs, reservePsgs } = getState().electronicInvoice;
    if (reservePsgs.length === 0) return false;
    return Promise.all(
      issuePsgs
        .filter(item => {
          return reservePsgs.indexOf(item.ticketNo) !== -1;
        })
        .map(item => {
          if (item.ticketNo.indexOf('-') !== -1) {
            item.ticketNo = item.ticketNo.split('-')[0];
          }
          return dispatch({
            type: CREATE_INVOICE,
            payload: {
              request: {
                url: urlConfig.createInvoice + '?' + item.ticketNo,
                method: 'post',
                data: filterProperty(item, [
                  'option',
                  'contactNo',
                  'address',
                  'depositBank',
                  'bankCardNo',
                  'peerRowPsgs',
                  'useInvoiceTitle',
                  'isEditOriginInvoiceTitle',
                  'psgType',
                ]),
              },
            },
          });
        })
    )
      .then(result => {
        dispatch(initInvoice());
      })
      .catch(err => {
        console.log(err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/routes/routes/electronicInvoice/modules/actions.js